class MedicalHistoryCurrentPregnancy {
    public Bleeding?: boolean;
    public NauseaVomiting?: boolean;
    public RashFeverIllness?: boolean;

    constructor(fields?: Partial<MedicalHistoryCurrentPregnancy>) {
        Object.assign(this, fields);
    }

    public setEmptyFieldsAsNo(): void {
        this.Bleeding = this.Bleeding || false;
        this.NauseaVomiting = this.NauseaVomiting || false;
        this.RashFeverIllness = this.RashFeverIllness || false;
    }
}

export { MedicalHistoryCurrentPregnancy };
